module.exports = __webpack_public_path__ + "static/media/target.4a6b8776.svg";